import axios, { bsHost, mngHost, parseFormData, def } from "apis/config";

type getLogProps = {
  ifa: string;
  "SKPAd-UUID"?: string;
  ifv?: string;
  device_id: number;
  date: string;
  time: string;
};

type inquiryProps = {
  public_id: string;
  app_id: string;
  app_name: string;
  ad_alloc_date: string;
  ad_alloc_time: string;
  email: string;
  cs_contents: string;
  ad_alloc_hist: string;
  files?: FileList;
};

const vocApi = {
  getLog: (payload: getLogProps) => {
    return axios.get(`${bsHost}/api/cssvc/clicks`, { params: def(payload) });
  },
  inquiry: (payload: inquiryProps) => {
    return axios.post(`${mngHost}/cs/api/inquiry`, parseFormData(payload), { headers: { "Content-Type": "multipart/form-data" } });
  },
};

export default vocApi;
export type { getLogProps, inquiryProps };
